import { getUserMgmtBase } from "../config/apiBase";
import { notifyAccessTokenRefreshed } from "./tokenEvents";

let inFlightRefreshPromise = null;

async function postSessionRefresh() {
  const base = getUserMgmtBase();
  const r = await fetch(`${base}/v1/user/session/refresh`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: "{}",
  });
  if (!r.ok) {
    return null;
  }
  const j = await r.json();
  const token = j.Token ?? j.token;
  const id = j.ID ?? j.id;
  if (!token || !id) {
    return null;
  }
  return { token, id };
}

async function refreshSessionSingleflight() {
  if (!inFlightRefreshPromise) {
    inFlightRefreshPromise = postSessionRefresh().finally(() => {
      inFlightRefreshPromise = null;
    });
  }
  return inFlightRefreshPromise;
}

/**
 * @param {object} options
 * @param {boolean} [options._retry] internal: avoid refresh loop
 */
export const InvokeAPI = async (
  url,
  data,
  myMethod,
  headers,
  withToken,
  userToken,
  options = {}
) => {
  const { _retry } = options;

  const Myheaders = new Headers();
  Myheaders.append("Content-Type", "application/json");
  if (withToken && userToken) {
    Myheaders.append("authorization", userToken);
  }

  if (headers) {
    Object.keys(headers).forEach(function (element) {
      Myheaders.append(element, headers[element]);
    });
  }

  const returnData = {
    retry: false,
    iserror: false,
    unauthenticated: false,
    unauthorized: false,
    alreadyExists: false,
    notfound: false,
    internal: false,
    invalidargument: false,
    rateLimitExceeded: false,
    othererror: false,
    response: {},
    errorMessage: "",
  };

  let response;
  try {
    response = await fetch(url, {
      method: myMethod,
      headers: Myheaders,
      body: JSON.stringify(data),
      credentials: "include",
    });
  } catch (error) {
    returnData.retry = true;
    return returnData;
  }
  if (!response.ok || response.status !== 200) {
    returnData.iserror = true;
    try {
      const errorData = await response.json();
      if (errorData.error || errorData.message) {
        returnData.errorMessage = errorData.error || errorData.message;
      }
    } catch (e) {
      // ignore non-JSON error bodies
    }

    if (response.status === 401) {
      if (!_retry) {
        const refreshed = await refreshSessionSingleflight();
        if (refreshed) {
          notifyAccessTokenRefreshed(refreshed);
          return InvokeAPI(url, data, myMethod, null, true, refreshed.token, {
            _retry: true,
          });
        }
      }
      returnData.unauthenticated = true;
    } else if (response.status === 403) {
      returnData.unauthorized = true;
    } else if (response.status === 400) {
      returnData.invalidargument = true;
    } else if (response.status === 404) {
      returnData.notfound = true;
    } else if (response.status === 409) {
      returnData.alreadyExists = true;
    } else if (response.status === 429) {
      returnData.rateLimitExceeded = true;
    } else if (response.status === 500) {
      returnData.internal = true;
    } else {
      returnData.othererror = true;
    }

    return returnData;
  }
  const resData = await response.json();
  returnData.response = resData;

  return returnData;
};
